export default {
  id: 36,
  title: 'Target #36 - Interleaved',
  url: 'https://cssbattle.dev/play/36',
  colors: ['#1A4341', '#F3AC3C', '#998235'],
  solution:
    '<a a><a b><style>body{background:#1A4341}a{position:fixed;width:50;height:200}a[a]{top:0;left:100;border-radius:0 0 25px 25px;background:#998235;box-shadow:150px 0 #998235}a[b]{bottom:0;left:25;border-radius:25px 25px 0 0;background:#F3AC3C;box-shadow:150px 0 #F3AC3C,300px 0 #F3AC3C}</style>',
}
